import $  from 'jquery';
import {setTotal} from "./setTotal";

export function addToBasket() {
    $('.js-product').each(function () {
        const input = $(this).find('input[name="quantity"]');
        const sum = $(this).find('.js-sum');
        const price = +$(this).find('.js-price').text();
        const step = +input.attr('step') || 1;

        $(this).find('.js-plus').click(function () {
            let quantity = +input.val() + step;
            input.val(quantity);
            sum.text(price * quantity);
            setTotal();
        });

        $(this).find('.js-minus').click(function () {
            let quantity = +input.val() - step;
            if (quantity >= 0) {
                input.val(quantity);
                sum.text(price * quantity);
                setTotal();
            }
        });
    });
}
